import {
  GET_ORGANIZATION_FSP_OVERVIEW_ERROR,
  GET_ORGANIZATION_FSP_OVERVIEW_START,
  GET_ORGANIZATION_FSP_OVERVIEW_SUCCESS,
} from 'constants/action-types/organizations/fspOrganizationOverview';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION_FSP_OVERVIEW_START:
      return {
        ...state,
        fspOrganizationOverview: {
          ...state.fspOrganizationOverview,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATION_FSP_OVERVIEW_SUCCESS:
      return {
        ...state,
        fspOrganizationOverview: {
          ...state.fspOrganizationOverview,
          loading: false,
          data: payload.data,
        },
      };
    case GET_ORGANIZATION_FSP_OVERVIEW_ERROR:
      return {
        ...state,
        fspOrganizationOverview: {
          ...state.fspOrganizationOverview,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
